<mat-spinner *ngIf="!main.activeItem"></mat-spinner>
<div *ngIf="main.activeItem">
  <div class="g-head g-hero" *ngIf="main.activeItem" [ngClass]="main.activeItem.status">
    <div class="g-hero-text">
      <div class="text">
        <div class="logo"><img src="assets/geislinger-logo.svg"></div>
        <h3>{{ main.activeItem.designation }}</h3>
        <h5 class="damper-id"><b>{{ main.activeItem.projectInfo }}</b></h5>
      </div>
    </div>
    <div class="g-hero-headline"><h1>Messages</h1></div>
  </div>

  <div class="columns">
    <!--SELECT ALL CHECKBOX-->
    <div class="select-all-checkbox">
      <mat-checkbox (click)="$event.stopPropagation()"
                    (change)="masterToggle()"
                    [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()"
                    [aria-label]="checkboxLabel()">
      </mat-checkbox>
    </div>

    <!--DELETE ALL SELECTED-->
    <span *ngIf="this.selection.selected.length > 0">
            <button mat-icon-button (click)="openDeleteSelectedMessagesDialog(selection.selected.length)">
                <mat-icon>delete</mat-icon>
            </button>
        </span>

    <!--SEARCH INPUT-->
    <div>
      <mat-form-field>
        <mat-label>Search</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Search" #input>
      </mat-form-field>
      <mat-icon>search</mat-icon>
    </div>
  </div>


  <!--TABS FOR MESSAGE TYPE FILTERING-->
  <mat-tab-group (selectedTabChange)="onTabChange($event)" *ngIf="main.activeItem" #tabs [(selectedIndex)]="index"
                 mat-stretch-tabs="false">
    <mat-tab [label]="MessagesTabLabel.All">
      <ng-template mat-tab-label>
            <span class="count" *ngIf="countUnreadMessagesForType(null) > 0"
                  [class.alarm]="countUnreadMessagesForType(MessageType.Alarm) > 0">
                {{ countUnreadMessagesForType(null) }}</span>
        ALL MESSAGES
      </ng-template>
    </mat-tab>
    <mat-tab [label]="MessagesTabLabel.Alarms">
      <ng-template mat-tab-label>
            <span class="alarm">
              <span class="count" *ngIf="countUnreadMessagesForType(MessageType.Alarm) > 0">
                {{ countUnreadMessagesForType(MessageType.Alarm) }}</span>
            ALARMS
            </span>
      </ng-template>
    </mat-tab>
    <mat-tab [label]="MessagesTabLabel.Warnings">
      <ng-template mat-tab-label>
            <span class="warn">
            <span class="count" *ngIf="countUnreadMessagesForType(MessageType.Warning) > 0">
                {{ countUnreadMessagesForType(MessageType.Warning) }}</span>
            WARNINGS
                </span>
      </ng-template>
    </mat-tab>
    <mat-tab [label]="MessagesTabLabel.OfflineWarnings">
      <ng-template mat-tab-label>
        <span class="warn">
          OFFLINE-WARNINGS
        </span>
      </ng-template>
    </mat-tab>
    <mat-tab [label]="MessagesTabLabel.Infos">
      <ng-template mat-tab-label>
            <span class="count" *ngIf="countUnreadMessagesForType(MessageType.Info) > 0">
                {{ countUnreadMessagesForType(MessageType.Info) }}</span>
        INFOS
      </ng-template>
    </mat-tab>
  </mat-tab-group>


  <!--TABLE-->
  <table mat-table *ngIf="main.activeItem"
         [dataSource]="dataSource" multiTemplateDataRows
         class="mat-elevation-z8">

    <!-- Checkbox Column -->
    <ng-container matColumnDef="select">
      <td mat-cell *matCellDef="let row">
        <mat-checkbox (click)="$event.stopPropagation()"
                      (change)="$event ? selection.toggle(row) : null"
                      [checked]="selection.isSelected(row)"
                      [aria-label]="checkboxLabel(row)">
        </mat-checkbox>
      </td>
    </ng-container>

    <!-- Engine Column -->
    <ng-container matColumnDef="engine">
      <th mat-header-cell *matHeaderCellDef>Engine</th>
      <td mat-cell *matCellDef="let row"
          [ngClass]="{'message-unread': !row.read, 'message-alarm': row.messageType === MessageType.Alarm, 'message-warn': row.messageType === MessageType.Warning}">
        {{ row.engineTitle }}
      </td> <!--({{row.engineIndex}})-->
    </ng-container>

    <!-- Sender Column -->
    <ng-container matColumnDef="sender">
      <th mat-header-cell *matHeaderCellDef>Sender</th>
      <td mat-cell *matCellDef="let row"
          [ngClass]="{'message-unread': !row.read, 'message-alarm': row.messageType === MessageType.Alarm, 'message-warn': row.messageType === MessageType.Warning}">
        <app-icon class="small-icon" [name]="row.messageType"></app-icon>
        {{ row.sender }}
      </td>
    </ng-container>

    <!-- Title Column -->
    <ng-container matColumnDef="shortTitle">
      <th mat-header-cell *matHeaderCellDef>Title</th>
      <td mat-cell *matCellDef="let row">
        @if (hasShortTitle(row)) {
          <div
            [ngClass]="{'message-unread': !row.read, 'message-alarm': row.messageType === MessageType.Alarm, 'message-warn': row.messageType === MessageType.Warning}">
            {{ row.shortTitle }}
          </div>
        } @else if (hasSubject(row)) {
          <div class="message-warn">
            {{ row.subject }}
          </div>
        }
      </td>
    </ng-container>

    <!-- Severity Column -->
    <ng-container matColumnDef="severity">
      <th mat-header-cell *matHeaderCellDef>Severity</th>
      <td mat-cell *matCellDef="let row"
          [ngClass]="{'message-unread': !row.read, 'message-alarm': row.messageType === MessageType.Alarm, 'message-warn': row.messageType === MessageType.Warning}">
        {{ row.severity }}
      </td>
    </ng-container>

    <!-- Time Column -->
    <ng-container matColumnDef="eventDate">
      <th mat-header-cell *matHeaderCellDef>Date</th>
      <td mat-cell *matCellDef="let row">
        @if (hasEventDate(row)) {
          <div
            [ngClass]="{'message-unread': !row.read, 'message-alarm': row.messageType === MessageType.Alarm, 'message-warn': row.messageType === MessageType.Warning}">
            {{ row.eventDate | date : 'y-MM-dd hh:mm:ss a zzzz' }}
          </div>
        } @else if (hasCreatedAt(row)) {
          <div class="message-warn">
            {{ row.createdAt | date:'y-MM-dd hh:mm:ss a zzzz' }}
          </div>
        }
      </td>
    </ng-container>

    <!-- Delete Column -->
    <ng-container matColumnDef="delete">
      <th mat-header-cell *matHeaderCellDef>Delete</th>
      <td mat-cell *matCellDef="let row"
          [ngClass]="{'message-unread': !row.read}">
        <button mat-icon-button (click)="delete(row)">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
    <ng-container matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplay.length">
        <div [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'" style="overflow: hidden">
          @if (hasShortTitle(element)) {
            <div class="message-body">
              <div class="message-text">
                <h3>{{ element.longTitle }}</h3>
                <p [innerHTML]="element.description"></p>

                <a [href]="createMailToLink(element)" (click)="$event.stopPropagation()" target="_top">
                  <button class="g-button" (click)="debug(element)">CONTACT SUPPORT</button>
                </a>
              </div>
            </div>
            <div class="g-hero-img"
                 *ngIf="element === expandedElement && element.alarmManualCurves?.title && (element.messageType === MessageType.Warning || element.messageType === MessageType.Alarm) ">
              <app-highchart [id]="element.shortTitle" class=""
                             [options]="element.chart"
                             style="min-width: 550px; min-height: 550px"></app-highchart>
            </div>
            <!--                    <div class="g-hero-img" *ngIf="message === expandedElement && message.messageType === MessageType.Warning">-->
              <!--                        <app-highchart [id]="main.messageDetailApp3Chart.id" class=""-->
              <!--                                       [options]="main.messageDetailApp3Chart"-->
              <!--                                       style="min-width: 550px; min-height: 550px"></app-highchart>-->
              <!--                    </div>-->
              <!--                    <div class="g-hero-img" *ngIf="message === expandedElement && message.messageType === MessageType.Alarm">-->
              <!--                        <app-highchart [id]="main.messageDetailApp2Chart.id" class=""-->
              <!--                                       [options]="main.messageDetailApp2Chart"-->
              <!--                                       style="min-width: 550px; min-height: 550px"></app-highchart>-->
              <!--                    </div>-->
          } @else if (hasSubject(element)) {
            <div class="message-body">
              <div class="message-text">
                <h3>{{ element.subject }}</h3>
                <p [innerHTML]="element.mailBody"></p>
                <br>
                <span>Attachments:</span>
                @for (attachment of element.attachments; track attachment) {
                  <div class="offline-warning-attachment">
                    <button mat-button (click)="downloadAttachment(attachment)">{{ attachment }}</button>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </td>
    </ng-container>

    <tr mat-row *matRowDef="let element; columns: columnsToDisplay;"
        [class.expanded-row]="expandedElement === element"
        (click)="expandedElement = (expandedElement === element) ? null : element; markMessageAsRead(element)">
    </tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>

    <!-- Row shown when there is no matching data. -->
    <ng-container *ngIf="input.value">
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="4">No message matching your filter "{{ input.value }}"</td>
      </tr>
    </ng-container>
    <ng-container *ngIf="!input.value">
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="4">None</td>
      </tr>
    </ng-container>
  </table>
</div>
